import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProjectCard from "../Post/Project/ProjectCard";
import { getProjectsFn } from "../APIServices/Services";
import { Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import Spinner from "../ui/Spinner";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";

export default function Projects() {
  // API request to get all projects
  const { data, isError, error, isLoading } = useQuery(
    ["projects"],
    getProjectsFn
  );

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Spinner />
        </Container>
      </Box>
    );
  }
  if (isError) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h4" component="h1" gutterBottom>
            Oops, something went wrong
          </Typography>
          <Typography variant="h5" component="h2" gutterBottom>
            {error.toString()}
          </Typography>
        </Container>
      </Box>
    );
  }

  if (data.results.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <CssBaseline />
        <Container component="main" sx={{ mt: 8, mb: 2 }} maxWidth="sm">
          <Typography variant="h4" component="h1" gutterBottom>
            No Projects added yet!
          </Typography>
        </Container>
      </Box>
    );
  }
  console.log(Object.values(data));
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container columns={{ xs: 4, sm: 8, md: 12 }}>
        <Typography
          component="h1"
          variant="h4"
          gutterBottom
        >
          Projects
        </Typography>
        {Object.values(data)[3].map((project, index) => (
          <Grid
            item
            xs={2}
            sm={4}
            md={4}
            key={index}
            style={{ marginTop: 4, top: 20 }}
          >
            <ProjectCard details={project} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
